// Shared modal shell — handles backdrop, ESC-to-close, body scroll lock.
// Pages embed their form content as children.

import React, { useEffect } from 'react';

export default function PortalModal({ open, onClose, title, children, size = 'default' }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  const sizeClass = size === 'narrow' ? 'narrow' : size === 'wide' ? 'wide' : '';

  return (
    <div className="portal-modal-backdrop" onClick={onClose}>
      <div
        className={`portal-modal ${sizeClass}`.trim()}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        {title && <h3>{title}</h3>}
        {children}
      </div>
    </div>
  );
}

export function ModalActions({ children }) {
  return <div className="portal-modal-actions">{children}</div>;
}
